import { render, staticRenderFns } from "./InventoryUpdated.vue?vue&type=template&id=8c141cfc"
import script from "./InventoryUpdated.vue?vue&type=script&lang=js"
export * from "./InventoryUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports